/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '@angular/material/snack-bar/simple-snack-bar';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from './simple-snack-bar.css.shim.ngstyle';
import * as import10 from '@angular/core/src/linker/view_container';
import * as import11 from '../../common/src/directives/ng_if.ngfactory';
import * as import12 from '@angular/core/src/linker/template_ref';
import * as import13 from '@angular/common/src/directives/ng_if';
var Wrapper_SimpleSnackBar = (function () {
    function Wrapper_SimpleSnackBar() {
        this._changed = false;
        this.context = new import0.SimpleSnackBar();
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_SimpleSnackBar.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_SimpleSnackBar.prototype.ngOnDestroy = function () {
    };
    Wrapper_SimpleSnackBar.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_SimpleSnackBar.prototype.checkHost = function (view, componentView, el, throwOnChange) {
        var currVal_0 = true;
        if (import3.checkBinding(throwOnChange, this._expr_0, currVal_0)) {
            view.renderer.setElementClass(el, 'mat-simple-snackbar', currVal_0);
            this._expr_0 = currVal_0;
        }
    };
    Wrapper_SimpleSnackBar.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_SimpleSnackBar.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_SimpleSnackBar;
}());
export { Wrapper_SimpleSnackBar };
var renderType_SimpleSnackBar_Host = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.None, [], {});
var View_SimpleSnackBar_Host0 = (function (_super) {
    __extends(View_SimpleSnackBar_Host0, _super);
    function View_SimpleSnackBar_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_SimpleSnackBar_Host0, renderType_SimpleSnackBar_Host, import6.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_SimpleSnackBar_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'simple-snack-bar', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_SimpleSnackBar0(this.viewUtils, this, 0, this._el_0);
        this._SimpleSnackBar_0_3 = new Wrapper_SimpleSnackBar();
        this.compView_0.create(this._SimpleSnackBar_0_3.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import8.ComponentRef_(0, this, this._el_0, this._SimpleSnackBar_0_3.context);
    };
    View_SimpleSnackBar_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import0.SimpleSnackBar) && (0 === requestNodeIndex))) {
            return this._SimpleSnackBar_0_3.context;
        }
        return notFoundResult;
    };
    View_SimpleSnackBar_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._SimpleSnackBar_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        this._SimpleSnackBar_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_SimpleSnackBar_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_SimpleSnackBar_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_SimpleSnackBar_Host0;
}(import2.AppView));
export var SimpleSnackBarNgFactory = new import8.ComponentFactory('simple-snack-bar', View_SimpleSnackBar_Host0, import0.SimpleSnackBar);
var styles_SimpleSnackBar = [import9.styles];
var View_SimpleSnackBar1 = (function (_super) {
    __extends(View_SimpleSnackBar1, _super);
    function View_SimpleSnackBar1(viewUtils, parentView, parentIndex, parentElement, declaredViewContainer) {
        var _this = _super.call(this, View_SimpleSnackBar1, renderType_SimpleSnackBar, import6.ViewType.EMBEDDED, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways, declaredViewContainer) || this;
        _this._expr_2 = import1.UNINITIALIZED;
        return _this;
    }
    View_SimpleSnackBar1.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.createRenderElement(this.renderer, null, 'button', new import3.InlineArray2(2, 'class', 'mat-simple-snackbar-action'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_0));
        this.init(this._el_0, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1
        ]), [disposable_0]);
        return null;
    };
    View_SimpleSnackBar1.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_2 = import3.inlineInterpolate(1, '', this.parentView.context.action, '');
        if (import3.checkBinding(throwOnChange, this._expr_2, currVal_2)) {
            this.renderer.setText(this._text_1, currVal_2);
            this._expr_2 = currVal_2;
        }
    };
    View_SimpleSnackBar1.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    View_SimpleSnackBar1.prototype.handleEvent_0 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.parentView.context.dismiss() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_SimpleSnackBar1;
}(import2.AppView));
var renderType_SimpleSnackBar = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.Emulated, styles_SimpleSnackBar, {});
var View_SimpleSnackBar0 = (function (_super) {
    __extends(View_SimpleSnackBar0, _super);
    function View_SimpleSnackBar0(viewUtils, parentView, parentIndex, parentElement) {
        var _this = _super.call(this, View_SimpleSnackBar0, renderType_SimpleSnackBar, import6.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import7.ChangeDetectorStatus.CheckAlways) || this;
        _this._expr_7 = import1.UNINITIALIZED;
        return _this;
    }
    View_SimpleSnackBar0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'span', new import3.InlineArray2(2, 'class', 'mat-simple-snackbar-message'), null);
        this._text_1 = this.renderer.createText(this._el_0, '', null);
        this._text_2 = this.renderer.createText(parentRenderNode, ' ', null);
        this._anchor_3 = this.renderer.createTemplateAnchor(parentRenderNode, null);
        this._vc_3 = new import10.ViewContainer(3, null, this, this._anchor_3);
        this._TemplateRef_3_5 = new import12.TemplateRef_(this, 3, this._anchor_3);
        this._NgIf_3_6 = new import11.Wrapper_NgIf(this._vc_3.vcRef, this._TemplateRef_3_5);
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._text_2,
            this._anchor_3
        ]), null);
        return null;
    };
    View_SimpleSnackBar0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import12.TemplateRef) && (3 === requestNodeIndex))) {
            return this._TemplateRef_3_5;
        }
        if (((token === import13.NgIf) && (3 === requestNodeIndex))) {
            return this._NgIf_3_6.context;
        }
        return notFoundResult;
    };
    View_SimpleSnackBar0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_3_0_0 = this.context.hasAction;
        this._NgIf_3_6.check_ngIf(currVal_3_0_0, throwOnChange, false);
        this._NgIf_3_6.ngDoCheck(this, this._anchor_3, throwOnChange);
        this._vc_3.detectChangesInNestedViews(throwOnChange);
        var currVal_7 = import3.inlineInterpolate(1, '', this.context.message, '');
        if (import3.checkBinding(throwOnChange, this._expr_7, currVal_7)) {
            this.renderer.setText(this._text_1, currVal_7);
            this._expr_7 = currVal_7;
        }
    };
    View_SimpleSnackBar0.prototype.destroyInternal = function () {
        this._vc_3.destroyNestedViews();
    };
    View_SimpleSnackBar0.prototype.createEmbeddedViewInternal = function (nodeIndex) {
        if ((nodeIndex == 3)) {
            return new View_SimpleSnackBar1(this.viewUtils, this, 3, this._anchor_3, this._vc_3);
        }
        return null;
    };
    return View_SimpleSnackBar0;
}(import2.AppView));
export { View_SimpleSnackBar0 };
//# sourceMappingURL=simple-snack-bar.ngfactory.js.map